import React, { useState, useEffect } from 'react';
import { Bell, BellOff } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '../../api/client';

export function AlertToggle() {
  const [alertsEnabled, setAlertsEnabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [alertCount, setAlertCount] = useState(0);

  useEffect(() => {
    fetchAlertStatus();
    fetchAlertCount();
  }, []);

  async function fetchAlertStatus() {
    try {
      const response = await api.get('/api/v1/alert-preferences/');
      setAlertsEnabled(response.alerts_enabled);
    } catch (error) {
      console.error('Error fetching alert status:', error);
    }
  }

  async function fetchAlertCount() {
    try {
      const response = await api.get('/api/v1/alert-preferences/filtered');
      setAlertCount(response.alerts?.length || 0);
    } catch (error) {
      console.error('Error fetching alert count:', error);
    }
  }

  async function toggleAlerts() {
    setLoading(true);
    try {
      await api.put('/api/v1/alert-preferences/', { alerts_enabled: !alertsEnabled });
      
      const newState = !alertsEnabled;
      setAlertsEnabled(newState);
      
      toast.success(
        newState
          ? 'Alerts enabled - you\'ll receive notifications again'
          : 'Alerts disabled - you won\'t see new notifications'
      );
      
      // Update count when toggling
      if (newState) {
        fetchAlertCount();
      } else {
        setAlertCount(0);
      }
    } catch (error) {
      console.error('Error toggling alerts:', error);
      toast.error('Failed to update alert settings');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="relative">
      <button
        onClick={toggleAlerts}
        disabled={loading}
        title={alertsEnabled ? 'Disable alerts' : 'Enable alerts'}
        className={`
          relative p-2 rounded-lg transition-all
          ${alertsEnabled 
            ? 'bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400' 
            : 'bg-gray-100 dark:bg-gray-800 text-gray-400'
          }
          hover:bg-opacity-80
          ${loading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
        `}
      >
        {alertsEnabled ? (
          <Bell className="w-5 h-5" />
        ) : (
          <BellOff className="w-5 h-5" />
        )}
        
        {/* Badge showing alert count (if enabled and count > 0) */}
        {alertsEnabled && alertCount > 0 && (
          <span className="absolute -top-1 -right-1 w-5 h-5 
                         bg-red-500 text-white text-xs font-bold
                         rounded-full flex items-center justify-center
                         animate-pulse">
            {alertCount > 9 ? '9+' : alertCount}
          </span>
        )}
      </button>
    </div>
  );
}

export default AlertToggle;